<!-- Header Structure -->
<template>
	<div>
		<v-navigation-drawer
			v-if="!horizontal"
			app
			fixed
			v-model="drawer"
			:mini-variant="collapseSidebar"
			mini-variant-width="70"
			:width="250"
			class="Vuely-sidebar"
			:style="{backgroundImage: 'url(' + selectedSidebarBgImage.url + ')'}"
			:class="{'background-none': !backgroundImage}"
			:right="rtlLayout"
		>
			<!-- App Sidebar -->
			<app-sidebar></app-sidebar>
		</v-navigation-drawer>
		<v-toolbar 
			class="Vuely-toolbar"
			app
			:color="activeHeaderFilter.class"
			fixed
		>	
			<div class="d-custom-flex align-items-center navbar-left">
				<div v-if="!horizontal">
					<v-toolbar-side-icon icon large @click.stop="drawer = !drawer" class="v-step-0"></v-toolbar-side-icon>
				</div>
				<div class="site-logo-wrap d-custom-flex ml-0 align-items-center" v-else>
					<router-link to="/horizontal/dashboard/ecommerce" class="grayish-blue site-logo-img">
						<img src="/static/img/site-logo.png" alt="site logo" width="100" height="30">
					</router-link>
				</div>

          <div :class="`hide-box-search`">
            <v-text-field flat solo prepend-icon="search" name="keywords" v-model="keywords" :placeholder="$t('message.search')" class="search-bar"></v-text-field>

            <div class="mobile-search d-none">
                <v-btn flat icon  small class="mobile-search-btn">
                    <v-icon class="font-md">search</v-icon>
                </v-btn>
            </div>

            <v-btn class="buttonSearch hidden-sm-only hidden-xs-only v-btn v-btn--router theme--dark blue" type="submit" v-on:click="submitSearch">search</v-btn>
          </div>

			</div>

      <!-- Button to change switch site view -->
      <template v-if="show_button_change_view">
        <v-btn class="buttonSwitchSiteView v-btn" color="secondary" type="button" @click="requestDesktopSite">Desktop view</v-btn>
      </template>
      <!-- End Button to change switch site view -->
      
			<div class="navbar-right">
				<div class="v-menu v-menu--inline"><img class="logo-tat" src="/static/img/logo-tat.png" alt=""></div>
				<v-btn icon large @click="toggleFullScreen" class="full-screen ma-0">
					<v-icon color="grey">fullscreen</v-icon>
				</v-btn>
				
				<!-- <v-btn class="ma-0" icon large @click.stop="chatSidebar = !chatSidebar">
					<v-icon color="grey">forum</v-icon>
				</v-btn> -->
				<!-- <notifications></notifications> -->
				<!-- <cart :horizontal="horizontal"></cart>
				<language-provider></language-provider> -->
			</div>
		</v-toolbar>
		<!-- Chat Searchbar -->
		<v-navigation-drawer fixed v-model="chatSidebar" :right="!rtlLayout" temporary app class="chat-sidebar-wrap">
			<!-- <chat-sidebar></chat-sidebar> -->
		</v-navigation-drawer>
		<mobile-search-form></mobile-search-form>
	</div>
</template>

<script>
import Sidebar from "../Sidebar/Sidebar.vue";
// import ChatSidebar from "../ChatSidebar/ChatSidebar.vue";
import screenfull from "screenfull";
import LanguageProvider from "./LanguageProvider";
import Notifications from "./Notifications";
import Cart from "./Cart";
import QuickLinks from "./QuickLinks";
import MobileSearchForm from "./MobileSearchForm";
import { getCurrentAppLayout, requestDesktopSite } from "Helpers/helpers";
import { mapGetters } from "vuex";
import MobileDetect from 'mobile-detect'

export default {
  props: {
    horizontal: {
      default: false,
      type: Boolean
    }
  },
  data() {
    return {
      show_button_change_view: false,
      collapsed: false, // collapse sidebar
      drawer: true, // sidebar drawer default true
      chatSidebar: false, // chat component right sidebar
      sidebarImages: "", // sidebar background images
      enableDefaultSidebar: false,
      keywords: ""
    };
  },
  computed: {
    ...mapGetters([
      "rtlLayout",
      "backgroundImage",
      "backgroundImage",
      "selectedSidebarBgImage",
			"darkMode",
			"collapseSidebar",
			"activeHeaderFilter"
    ])
	},
	mounted () {
		this.$nextTick(() => {
            // let button_search = '<a href="#" class="buttonSearch v-btn v-btn--router theme--dark blue"><div class="v-btn__content">SEARCH</div></a>'
            // let button_search = '<button class="buttonSearch v-btn v-btn--router theme--dark blue" v-on:click="submitSearch"><div class="v-btn__content">SEARCH</div></button>'
            // $('.search-bar').append(button_search);
		})
    },
    async created() {
        this.keywords = this.$route.params.keywords

        let md = new MobileDetect(window.navigator.userAgent);
        if (md.mobile() != null) {
          this.show_button_change_view = true;
        } else {
          this.show_button_change_view = false;
        }
    },
  methods: {
    // toggle full screen method
    toggleFullScreen() {
        if (screenfull.enabled) {
            screenfull.toggle();
        }
	  },
	  getMenuLink(link) {
		  return '/' + getCurrentAppLayout(this.$router) + link;
    },
    submitSearch(){
        if(this.keywords){
            this.$router.push("/admin/search/" + this.keywords);
        }
    },
    requestDesktopSite() {
     requestDesktopSite();
    }
  },
  components: {
    appSidebar: Sidebar,
    // ChatSidebar,
    LanguageProvider,
    Notifications,
    Cart,
    QuickLinks,
    MobileSearchForm
  }
};
</script>
<style scoped>
    .buttonSearch {
        padding: 0;
        margin: 0;
        height: 40px;
    }
    .buttonSwitchSiteView {
      padding: 0;
      margin: 0;
      margin: 0 auto;
      float: none;
      height: 31px;
      width: 110px;
      background: #5cbbf6 !important;
      border-color: #5cbbf6 !important;
    }
    .hide-box-search {
      display:none;
    }
</style>

